import { IconButton, Typography } from "@mui/material"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import React, { FunctionComponent } from "react"

export const NodeDetailsLabel: FunctionComponent<{ label: string }> = ({ label }) => {
  return (
    <Typography variant="h6">
      <strong>{label}</strong>
      <IconButton onClick={() => navigator.clipboard.writeText(label)}>
        <ContentCopyIcon />
      </IconButton>
    </Typography>
  )
}
